import { AnalyticsService } from './analyticsService'
import { GoogleAnalyticsProvider } from './googleAnalytics'

let analyticsService: AnalyticsService | null = null

if (typeof window !== 'undefined') {
  if (!(window as any).dataLayer) {
    ;(window as any).dataLayer = []
  }

  const analyticsProvider = new GoogleAnalyticsProvider()
  analyticsService = AnalyticsService.getInstance(analyticsProvider)
}

export default analyticsService
